import 'babel-polyfill'
import '@babel/polyfill'
import Vue from "vue";
import App from "./App.vue";
import router from "./routes";
import { BootstrapVue, IconsPlugin } from "bootstrap-vue";
import VueSweetalert2 from 'vue-sweetalert2';
Vue.use(VueSweetalert2);
Vue.config.productionTip = false
import axios from "axios";
import AOS from 'aos'
import 'aos/dist/aos.css'
import Vuelidate from "vuelidate";
import swal from 'sweetalert';
Vue.use(Vuelidate);
/*
 Register the object here globally as directive, 
*/
// Install BootstrapVue
Vue.use(BootstrapVue);
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin);
Vue.config.productionTip = false;

router.beforeEach((to, from, next) => {

  setTimeout(() => { window.scrollTo(0, 0); }, 300);


  if (window.localStorage.getItem("profile") == null) {
    if (to.name != "Home" && to.name != "Login" && to.name != "ForgetPassword" && to.name != "Search" && to.name != "Change_success" && to.name != "Reset_password" && to.name != "Registration") {
      next({ name: "Login" });
      swal({
        text: 'দুঃখিত, পেজটির প্রবেশের আগে লগইন করুন!',
        buttons: {
          confirm: { text: 'ঠিক আছে' },
        },
      });
      router.reload()
    } else {
      next();
    }
  } else {
    if (to.name == "Login" || to.name == "Registration") {
      next({ name: "Home" });
    } else {
      next();
    }
  }

});

// Make sure sw are supported
//if ('serviceWorker' in navigator) {
// console.log('service worked')
//  window.addEventListener('load', () => {
//    axios.get(this.$root.API_BASE_URL+"get-course-file?course_id=7")
//    .then((response) => {
//     let request = indexedDB.open('cacheURL', 1);
//     request.onupgradeneeded = function(event) {
//       var db = event.target.result;
//       var objectStore = db.createObjectStore('cacheURL');
//        var urlList = response.data.data;
//        objectStore.add(JSON.stringify(urlList), "URL");
//       setTimeout(() => {
//          navigator.serviceWorker
//         .register('sw_cached_pages.js') 
//         .then((reg) => {
//            console.log('Service Worker: registration',reg)
//          })
//          .catch(err => console.log(`Service Worker: Error: ${err}`));
//        }, 3000);
//     }
//   });  
//  });
//}

new Vue({
  created() {
    AOS.init({ once: true })
  },
  router,
  components: { App },
  template: '<App/>',
  mounted() {
    window.scrollTo(0, 0);
    if (window.localStorage.getItem("profile") != null) {
      this.user_profile = JSON.parse(window.localStorage.getItem("profile"));
      this.logged_in = true;
    }
    this.translate = true;
    // if (window.localStorage.getItem("language") != null) {
    //   this.translate = window.localStorage.getItem("language");
    // } else {
    //   window.localStorage.setItem("language", true);
    // }
  },
  data() {
    return {
      translate: true,
      API_BASE_URL: "https://adolescent.nnsop.org/admin-panel/api/",
      hideSearch: true,
      selected_course: 0,
      course_list: [],
      user_profile: [],
      logged_in: false,
      language: {
        text: "Eng",
      },
      ragistration: {
        text: "রেজিস্ট্রেশন",
      },
      login: {
        text: "লগইন",
      },
      Mycourse: {
        text: "আমার কোর্স",
      },
      Courses: {
        text: "কোর্সসমূহ",
      },
      training: {
        text: "প্রশিক্ষণের বিবরণ",
      },
      footer_head: {
        footer_text: "পুষ্টি বিষয়ক প্রশিক্ষনের যৌথ পরিকল্পনা ও বাস্তবায়নে",
      },
      footer_text: {
        footer_sub_text: "প্রশিক্ষণের বিবরণ",
      },
      footer_text1: {
        footer_sub_text1: "কোর্সসমূহ",
      },
      footer_text2: {
        footer_sub_text2: "আমার কোর্স",
      },
      footer_text3: {
        footer_sub_text3: "আমার প্রোফাইল",
      },
      footer_text4: {
        footer_sub_text4: "ডিজাইন ও ডেভেলপমেন্টঃ",
      },
      footer_text5: {
        footer_sub_text5: " রাইজআপ ল্যাবস",
      },
      login_head: {
        login_text: "লগইন",
      },
      login_email: {
        login_e_text: "ইমেইল",
      },
      login_password: {
        login_p_text: "পাসওয়ার্ড",
      },
      login_forget: {
        login_f_text: "পাসওয়ার্ড ভুলে গেছেন?",
      },
      rg_head: {
        rg_text: "রেজিস্ট্রেশন",
      },
      rg_name: {
        rg_n_text: "নাম",
      },
      rg_number: {
        rg_m_text: "মোবাইল নাম্বার",
      },
      rg_add: {
        rg_add_text: "আপনি সংযুক্ত আছেন",
      },
      rg_gender: {
        rg_gen_text: "লিঙ্গ",
      },
      rg_gender1: {
        rg_gen_text1: "পুরুষ",
      },
      rg_gender2: {
        rg_gen_text2: "মহিলা",
      },
      rg_gender3: {
        rg_gen_text3: "অন্যান্য",
      },
      rg_ins: {
        rg_ins_text:
          "আপনার সংস্থা / প্রতিষ্ঠান / স্কুল / কমিউনিটি ক্লাব এর নাম লিখুন",
      },
      rg_designation: {
        rg_des_text: "পদবী",
      },
      rg_age: {
        rg_age_text: "বয়স",
      },
      rg_re_pass: {
        rg_re_pass_text: "পাসওয়ার্ড নিশ্চিত করুন",
      },
      rg_division: {
        rg_divi_text: "বিভাগ",
      },
      rg_district: {
        rg_dist_text: "জেলা",
      },
      rg_upazila: {
        rg_upazala_text: "উপজেলা",
      },
      home_img_1: {
        head: "পুষ্টি বিষয়ক অনলাইন প্রশিক্ষণ :",
      },
      home_img_1_subhead: {
        sub_head: " নির্দিষ্ট পুষ্টি উন্নয়ন কার্যক্রম নিশ্চিতকরণ",
      },
      home_img_2: {
        head: "কৈশোরকালীন পুষ্টি শিক্ষা :",
      },
      home_img_2_subhead: {
        sub_head: "বর্তমান ও ভবিষ্যতের সঠিক ",
      },
      home_img_2_subsubhead: {
        sub_sub_head: "খাদ্যাভাস গড়ে তুলতে সহায়তা করবে",
      },
      home_img_3: {
        head: "সঠিক পুষ্টিকর খাবার যেমন :",
      },
      home_img_3_subhead: {
        sub_head: "আমিষ, শর্করা ও স্নেহ জাতীয় খাবার",
      },
      home_img_3_subsubhead: {
        sub_sub_head: "ছাত্র-ছাত্রীদের জ্ঞান, মনোযোগ, শক্তি বৃদ্ধি করে",
      },
      home_img: {
        button_text: "সকল কোর্স",
      },
      home_body: {
        left_head: "পুষ্টি বিষয়ক প্লাটফর্মটির উদ্দেশ্য",
      },
      home_body_text: {
        left_head_text:
          " স্বাস্থ্য ও পরিবার কল্যাণ মন্ত্রণালয় মা, শিশু এবং কিশোর-কিশোরীদের কার্যক্রম সমূহ বাস্তবায়নের জন্য পুষ্টি প্রশিক্ষণ কর্মসূচিটি পরিচালনা করেছে। এই প্ল্যাটফর্ম থেকে প্রশিক্ষণ নিয়ে আপনি পুষ্টি প্রোগ্রামের বিভিন্ন উপাদান সম্পর্কে জ্ঞান এবং দক্ষতা অর্জন করতে পারবেন। জাতীয় পুষ্টিসেবা/ জনস্বাস্থ্য পুষ্টি প্রতিষ্ঠান, মাধ্যমিক ও উচ্চ শিক্ষা অধিদপ্তর (মাউশি) এবং ইউনিসেফ-এর বিশেষজ্ঞদের যৌথভাবে তৈরি করা অনলাইন পুষ্টি কোর্সে অংশগ্রহন করতে বিনামূল্যে সাইন আপ করুন।",
      },
      home_body_sub: {
        left_head_sub: "পুষ্টি বিষয়ক প্লাটফর্মটি",
      },
      home_body_sub_text: {
        left_head_sub_text: "সকলের জন্য উন্মুক্ত",
      },
      home_body_sub_text1: {
        left_head_sub_text1: "অফলাইন ক্ষমতা সম্পন্ন",
      },
      h_body_r: {
        r_course: "চলমান কোর্স",
      },
      h_body_buton_q: {
        q_button: "অনলাইনে শুরু করুন",
      },
      h_body_b: {
        r_button: "শুরু করুন",
      },
      h_body_l: {
        l_head: "কৈশোরকালীন পুষ্টি কার্যক্রম বাস্তবায়নে গাইডলাইন ২০২০",
      },
      h_body_l_p: {
        l_head_p:
          " কৈশোরকালীন পুষ্টি কার্যক্রম বাস্তবায়নের গাইডলাইনটি মাধ্যমিক বিদ্যালয় পর্যায়ে পুষ্টি কার্যক্রমসমূহ বাস্তবায়নের লক্ষ্যে বিভিন্ন অধিদপ্তর, বিভাগ এবং প্রতিষ্ঠানের মধ্যকার কাজের সমন্বয় কৌশলটি ব্যাখ্যা করেছে। একইসাথে অন্যান্য প্রাসঙ্গিক প্রোগ্রামের কর্মকর্তা ও অংশীদারগণ মাধ্যমিক বিদ্যালয়ভিত্তিক ক্লাব, মাদ্রাসা, কিশোর-কিশোরীদের কমিউনিটি ক্লাব এবং কিশোর-কিশোরীদের স্বাস্থ্যসেবা প্রদানকারী দপ্তরগুলোর সংশ্লিষ্ট কার্যক্রম পরিকল্পনা, বাস্তবায়ন, পর্যবেক্ষণের জন্য এই নীতিমালা রেফারেন্স টুল হিসেবে ব্যবহার করবেন।",
      },
      h_body_b2: {
        l_head_b: " গাইড লাইন",
      },
      h_body_right2: {
        right_head2: "মোবাইল প্লাটফর্ম",
      },
      h_body_right2_p: {
        right_head2_p:
          " মোবাইল প্লাটফর্ম থেকেও যে কোনো সময় যে কোনো স্থান থেকে অফলাইনে পুষ্টি বিষয়ক অনলাইন কোর্সে অংশগ্রহণের মাধ্যমে ব্যাবহারকারীরা বিভিন্ন বিষয়ে জ্ঞান ও দক্ষতা অর্জন করতে পারবেন।",
      },
      module_count: {
        r_modules: "টি মডিউল",
      },
      search: {
        place: "কোর্স খুঁজুন",
      },
      edit_pass: {
        edit_text: "পুরানো পাসওয়ার্ড",
      },
      edit_pass_n: {
        edit_text_n: "নতুন পাসওয়ার্ড",
      },
      edit_pass_r: {
        edit_text_r: "নতুন পাসওয়ার্ড নিশ্চিত করুন",
      },
      edit_pro_b: {
        edit_pro_b_text: "আপডেট পাসওয়ার্ড",
      },
      select: {
        text_select: "নির্বাচন করুন",
      },
      Mycourse_pro: {
        text_pro: "প্রোফাইল",
      },
      model: {
        text_model: "চলমান মডিউল",
      },
      model_course: {
        text_model_c: "কোর্স",
      },
      model_date: {
        text_model_d: "তারিখ",
      },
      new_course: {
        text_new: "নতুন কোর্স",
      },
      review: {
        text_review: "মূল্যায়ন",
      },
      review_q: {
        text_review_q: "এই কোর্সের সাথে আপনার অভিজ্ঞতা কেমন ছিল?",
      },
      review_q1: {
        text_review_q1: "এই কোর্সটির উদ্দেশ্যগুলি পরিষ্কার ছিল :",
      },
      review_q2: {
        text_review_q2: "কোর্সটি থেকে শিক্ষণীয় বিষয়গুলি জানতে পেরেছি",
      },
      review_q3: {
        text_review_q3: "কোর্সটি আমার কাজের ক্ষেত্রে প্রাসঙ্গিক/প্রযোজ্য",
      },
      review_q4: {
        text_review_q4:
          "আপনি কি আপনার সহকর্মীদের বা বন্ধুদের এই কোর্সটি সম্পর্কে জানাবেন ?",
      },
      review_ans: {
        text_review_ans: "অসন্তোষজনক",
      },
      review_ans1: {
        text_review_ans1: "সন্তোষজনক",
      },
      review_ans2: {
        text_review_ans2: "ভাল",
      },
      review_ans3: {
        text_review_ans3: "খুব ভাল",
      },
      review_ans4: {
        text_review_ans4: "চমৎকার",
      },
      review_ans5: {
        text_review_ans5: "অসম্মতি",
      },
      review_ans6: {
        text_review_ans6: "একমত",
      },
      review_ans7: {
        text_review_ans7: "কোন মন্তব্য নেই",
      },
      review_ans8: {
        text_review_ans8: "হ্যাঁ",
      },
      review_ans9: {
        text_review_ans9: "না",
      },
      review_submit: {
        text_review_submit: "জমা দিন",
      },
      certificate: {
        text_cer: "সনদপত্র",
      },
      certificate_h: {
        text_cer_h: "সনদপত্রটি ডাউনলোড করুন",
      },
      certificate_b: {
        text_cer_b: "ডাউনলোড",
      },
      course_des_p: {
        text_des_p: "কোর্সের উদ্দেশ্য",
      },
      course_des_m: {
        text_des_m: "কোর্সের পদ্ধতি",
      },
      course_des_c: {
        text_des_c: "পাঠতালিকা",
      },
      course_des_m_t: {
        text_des_m_t: "মোট মডিউল :",
      },
      course_des_m_tt: {
        text_des_m_tt: "টি",
      },
      course_des_t_t: {
        text_des_t_t: "মোট সময় :",
      },
      course_des_t_tt: {
        text_des_t_tt: "ঘণ্টা",
      },
      course_des_t_m: {
        text_des_t_m: "মিনিট",
      },
      seen: true,
      bangla: true,
      english: false,
      registration_hook: null,
      page_hook: null,
      quizDone: false,
      reviewDone: false,
      certificateAvailable: false,
    };
  },

  methods: {
    cacheAPI() {
      var user_profile = JSON.parse(window.localStorage.getItem("profile"));
      var config = {
        headers: {
          "X-localization": this.translate ? "bn" : "en",
          Authorization: "bearer " + user_profile.token
        }
      };

      axios.get(this.$root.API_BASE_URL + "review-question", config)
        .then((response) => {
          if (response.data == []) { return; }
          // Save Locally
          localStorage.setItem("review-question", JSON.stringify(response.data.data));
        });

      axios.get(this.API_BASE_URL +
        "getcourse", config
      ).then(response => {
        if (response.data == []) { return; }
        localStorage.setItem(
          "getcourse", JSON.stringify(response.data.data)
        );
        for (var i = 0; i < response.data.data.length; i++) {
          var course_id = response.data.data[0].id;
          axios.get(this.API_BASE_URL +
            "get-course-module?course_id=" + course_id, config
          ).then(response => {
            if (response.data == []) { return; }
            localStorage.setItem(
              "get-course-module-" + course_id, JSON.stringify(response.data.data)
            );
          }
          );
        }
      }
      );

      axios.get(this.API_BASE_URL + "get-my-course", config)
        .then(response => {
          if (response.data == []) { return; }
          localStorage.setItem(
            "get-my-course", JSON.stringify(response.data.data)
          );
        }
        );

      // Load WorkBox
      if ("serviceWorker" in navigator) {
        console.log("Service Worker: Available");
        navigator.serviceWorker.register("../wb_sw.js")
          .catch(
            function (t) {
              console.error("SW registration failed: ", t);
            }
          )
      } else {
        console.log("Service Worker: Not Available");
      }

    },
    submittedQuiz(event = null) {
      var user_profile = JSON.parse(window.localStorage.getItem("profile"));
      var config = {
        headers: {
          "X-localization": this.$root.translate ? "bn" : "en",
          Authorization: "bearer " + user_profile.token,
        },
      };
      axios
        .get(this.$root.API_BASE_URL + "certificate-check?course_id=" + this.$root.getSelectedCourse(), config)
        .then((response) => {
          console.log(response.data);

          if (response.data == []) {
            return;
          }

          if (response.data.code == 200) {
            console.log(event);
            this.quizDone = true;
            if (event != null) {
              this.checkReview(null, event);
            }
          }
        });
    },
    checkReview(event = null, event2 = null) {
      if (this.getLocalValue("review_done") != null) {
        return;
      }

      var user_profile = JSON.parse(window.localStorage.getItem("profile"));
      var config = {
        headers: {
          "X-localization": this.$root.translate ? "bn" : "en",
          Authorization: "bearer " + user_profile.token,
        },
      };
      axios
        .get(this.$root.API_BASE_URL + "check-review", config)
        .then((response) => {

          if (response.data == []) {
            return;
          }

          if (response.data.code == 200) {
            this.reviewDone = true;
            this.certificateAvailable = true;
            this.setLocalValue("review_done", "true");
            if (event != null) {
              event();
            }
          } else {
            this.reviewDone = false;
            this.certificateAvailable = false;
            if (event2 != null) {
              event2();
            }
          }
        });
    },
    getLocalValue(param) {
      if (window.localStorage.getItem("_param_" + param) != null) {
        return window.localStorage.getItem("_param_" + param);
      } else {
        return null;
      }
    },
    setLocalValue(param, value) {
      window.localStorage.setItem("_param_" + param, value);
    },
    selectCourse(id) {
      this.selected_course = id;
      window.localStorage.setItem("selected_course", id);
    },
    getSelectedCourse() {
      return 7;
      // if (window.localStorage.getItem("selected_course") != null) {
      //   this.selected_course = window.localStorage.getItem("selected_course");
      //   return this.selected_course;
      // } else {
      //   return 0;
      // }
    },
    logout() {
      var user_profile = JSON.parse(window.localStorage.getItem("profile"));
      var config = {
        headers: {
          "X-localization": this.$root.translate ? "bn" : "en",
          Authorization: "bearer " + user_profile.token,
        },
      };

      axios
        .post(this.$root.API_BASE_URL + "security-logout", config)
        .then(() => {
          this.user_profile = [];
          this.logged_in = false;
          window.localStorage.removeItem("profile");
          window.localStorage.clear();
         // this.$router.push("/login");
         
          this.$router.push({ name: 'Login'});
          location.reload();
        })
        .catch(() => {
          this.user_profile = [];
          this.logged_in = false;
          window.localStorage.removeItem("profile");
          window.localStorage.clear();
          this.$router.push({ name: 'Login'});
          //this.$router.push("/login");
          location.reload();
        });
    },
    syncOnline() {
      // Sync Progress if Online
      if (navigator.onLine) {
        if (localStorage.getItem("profile") != null) {
          var user_profile = JSON.parse(window.localStorage.getItem("profile"));
          var config = {
            headers: {
              Authorization: "bearer " + user_profile.token
            }
          };

          for (var i = 0; i < 1000; i++) {
            if (localStorage.getItem("_progress_" + i) != null) {
              var localData = JSON.parse(localStorage.getItem("_progress_" + i));
              if (localData.sync == false) {
                axios.post(this.$root.API_BASE_URL + 'module-progress-add', {
                  'course_module_id': localData.course_module_id,
                  'complete_percent': localData.complete_percent
                }, config);

                var localPack = {
                  'course_module_id': localData.course_module_id,
                  'complete_percent': localData.complete_percent,
                  'sync': true
                }
                localStorage.setItem("_progress_" + i, JSON.stringify(localPack));
              }
            }
          }

          if (localStorage.getItem("_quiz") != null) {
            var localQuiz = JSON.parse(localStorage.getItem("_quiz"));
            if (localQuiz.sync != true) {
              axios.post(this.$root.API_BASE_URL + 'quiz-result-submit', {
                'course_module_id': localQuiz.course_module_id,
                'percentage': localQuiz.percentage,
                'gain_point': localQuiz.gain_point,
              }, config).then(() => {
                var quizPack = {
                  'course_module_id': localQuiz.course_module_id,
                  'percentage': localQuiz.percentage,
                  'gain_point': localQuiz.gain_point,
                  'sync': true
                }
                localStorage.setItem("_quiz", JSON.stringify(quizPack));
              });
            }
          }

          if (localStorage.getItem("_review") != null) {
            var localReview = JSON.parse(localStorage.getItem("_review"));
            if (localReview.sync != true) {
              var reviewBody = { review_question_answer_id: localReview.review_question_answer_id }
              axios.post(this.$root.API_BASE_URL + "user-review-submit", reviewBody, config)
                .then(() => {
                  var reviewData = { review_question_answer_id: localReview.review_question_answer_id, sync: true }
                  localStorage.setItem("_review", JSON.stringify(reviewData));
                });
            }
          }
        }
      }
    },
    toggleSeen: function () {
      // Save to Local Storage

      // Load from Local Storage
      this.bangla = !this.bangla;
      this.english = !this.english;
      //this.translate = !this.translate;
      window.localStorage.setItem("language", this.translate);
      //navber
      this.language.text = this.translate ? "Eng" : "Ban";
      this.ragistration.text = this.translate ? "রেজিস্ট্রেশন" : "Registration";
      this.login.text = this.translate ? "লগইন" : "Login";
      this.Mycourse.text = this.translate ? "আমার কোর্স" : "My Course";
      this.Courses.text = this.translate ? "কোর্সসমূহ" : "Courses";
      this.training.text = this.translate
        ? "প্রশিক্ষণের বিবরণ"
        : "Overview of Training";
      this.search.place = this.translate ? "কোর্স খুঁজুন" : "Search Course";
      //footer
      this.footer_head.footer_text = this.translate
        ? "পুষ্টি বিষয়ক প্রশিক্ষনের যৌথ পরিকল্পনা ও বাস্তবায়নে"
        : "Joint planning and implementation of nutrition training";
      this.footer_text.footer_sub_text = this.translate
        ? "প্রশিক্ষণের বিবরণ"
        : "Overview of training";
      this.footer_text1.footer_sub_text1 = this.translate ? "কোর্সসমূহ" : "Courses";
      this.footer_text2.footer_sub_text2 = this.translate
        ? "আমার কোর্স"
        : "My Course";
      this.footer_text3.footer_sub_text3 = this.translate
        ? "আমার প্রোফাইল"
        : "My Profile";
      this.footer_text4.footer_sub_text4 = this.translate
        ? "ডিজাইন ও ডেভেলপমেন্টঃ"
        : "Designed & Developed:";
      this.footer_text5.footer_sub_text5 = this.translate
        ? " রাইজআপ ল্যাবস"
        : " Riseup Labs";
      //login
      this.login_head.login_text = this.translate ? "লগইন" : "Login";
      this.login_email.login_e_text = this.translate ? "ইমেইল" : "Email";
      this.login_password.login_p_text = this.translate ? "পাসওয়ার্ড" : "Password";
      this.login_forget.login_f_text = this.translate
        ? "পাসওয়ার্ড ভুলে গেছেন?"
        : "Forgot password?";

      //registration
      this.rg_head.rg_text = this.translate ? "রেজিস্ট্রেশন" : "Registration";
      this.rg_name.rg_n_text = this.translate ? "নাম" : "Name";
      this.rg_number.rg_m_text = this.translate ? "মোবাইল নাম্বার" : "Phone Number";
      this.rg_add.rg_add_text = this.translate
        ? "আপনি সংযুক্ত আছেন"
        : "You are affiliated to";
      this.rg_gender.rg_gen_text = this.translate ? "লিঙ্গ" : "Gender";
      this.rg_gender1.rg_gen_text1 = this.translate ? "পুরুষ" : "Male";
      this.rg_gender2.rg_gen_text2 = this.translate ? "মহিলা" : "Female";
      this.rg_gender3.rg_gen_text3 = this.translate ? "অন্যান্য" : "Others";
      this.rg_ins.rg_ins_text = this.translate
        ? "আপনার সংস্থা / প্রতিষ্ঠান / স্কুল / কমিউনিটি ক্লাব এর নাম লিখুন"
        : "Please specify your Organization/Institution/School/Community";
      this.rg_designation.rg_des_text = this.translate ? "পদবী" : "Designation";
      this.rg_age.rg_age_text = this.translate ? "বয়স" : "Age";
      this.rg_re_pass.rg_re_pass_text = this.translate
        ? "পাসওয়ার্ড নিশ্চিত করুন"
        : "Re-Type password";
      this.rg_division.rg_divi_text = this.translate ? "বিভাগ" : "Division";
      this.rg_district.rg_dist_text = this.translate ? "জেলা" : "District";
      this.rg_upazila.rg_upazala_text = this.translate ? "উপজেলা" : "Upazila";
      this.select.text_select = this.translate ? "নির্বাচন করুন" : "Select";

      //home page landing img first
      this.home_img_1.head = this.translate
        ? "পুষ্টি বিষয়ক অনলাইন প্রশিক্ষণ :"
        : "Online Nutrition Training :";
      this.home_img_1_subhead.sub_head = this.translate
        ? "নির্দিষ্ট পুষ্টি উন্নয়ন কার্যক্রম নিশ্চিতকরণ"
        : "To ensure specific nutritional activities";
      //home page landing img second
      this.home_img_2.head = this.translate
        ? "কৈশোরকালীন পুষ্টি শিক্ষা "
        : "Adolescent nutrition education";
      this.home_img_2_subhead.sub_head = this.translate
        ? "বর্তমান ও ভবিষ্যতের সঠিক "
        : "will help to build the right eating";
      this.home_img_2_subsubhead.sub_sub_head = this.translate
        ? "খাদ্যাভাস গড়ে তুলতে সহায়তা করবে"
        : "habits for today and the next days";
      //home page landing img third
      this.home_img_3.head = this.translate
        ? "সঠিক পুষ্টিকর খাবার যেমন :"
        : "Proper nutritious foods such as";
      this.home_img_3_subhead.sub_head = this.translate
        ? "আমিষ, শর্করা ও স্নেহ জাতীয় খাবার"
        : "non-vegetarian, carbohydrate and fatty foods";
      this.home_img_3_subsubhead.sub_sub_head = this.translate
        ? "ছাত্র-ছাত্রীদের জ্ঞান, মনোযোগ, শক্তি বৃদ্ধি করে"
        : 'increase students" knowledge, attention and energy';
      // //home page landing img button
      this.home_img.button_text = this.translate ? "সকল কোর্স" : "All Course";
      //home page body right text
      this.home_body.left_head = this.translate
        ? "পুষ্টি বিষয়ক প্লাটফর্মটির উদ্দেশ্য"
        : "Purpose of the nutrition platform";
      this.home_body_text.left_head_text = this.translate
        ? " স্বাস্থ্য ও পরিবার কল্যাণ মন্ত্রণালয় মা, শিশু এবং কিশোর-কিশোরীদের কার্যক্রম সমূহ বাস্তবায়নের জন্য পুষ্টি প্রশিক্ষণ কর্মসূচিটি পরিচালনা করেছে। এই প্ল্যাটফর্ম থেকে প্রশিক্ষণ নিয়ে আপনি পুষ্টি প্রোগ্রামের বিভিন্ন উপাদান সম্পর্কে জ্ঞান এবং দক্ষতা অর্জন করতে পারবেন। জাতীয় পুষ্টিসেবা/ জনস্বাস্থ্য পুষ্টি প্রতিষ্ঠান, মাধ্যমিক ও উচ্চ শিক্ষা অধিদপ্তর (মাউশি) এবং ইউনিসেফ-এর বিশেষজ্ঞদের যৌথভাবে তৈরি করা অনলাইন পুষ্টি কোর্সে অংশগ্রহন করতে বিনামূল্যে সাইন আপ করুন।"
        : "Ministry of Health and Family welfare is implementing nutrition programs for mother, children and adolescents. This platform will provide you improve knowledge and skills about different component of nutrition program. Sign up now for the free online nutrition course from the technical experts working jointly from NNS/IPHN, DSHE and UNICEF";
      this.home_body_sub.left_head_sub = this.translate
        ? "পুষ্টি বিষয়ক প্লাটফর্মটি"
        : "The Nutrition Platform is:";
      this.home_body_sub_text.left_head_sub_text = this.translate
        ? "সকলের জন্য উন্মুক্ত"
        : "Open for all";
      this.home_body_sub_text1.left_head_sub_text1 = this.translate
        ? "অফলাইন ক্ষমতা সম্পন্ন"
        : "Offline capabilities";
      //home page body right course
      this.h_body_r.r_course = this.translate ? "চলমান কোর্স" : "Ongoing Course";
      this.h_body_b.r_button = this.translate ? "শুরু করুন" : "Start";
      this.module_count.r_modules = this.translate ? " টি মডিউল" : " Module";
      //home page body right text 1
      this.h_body_l.l_head = this.translate
        ? "কৈশোরকালীন পুষ্টি কার্যক্রম বাস্তবায়নে গাইডলাইন ২০২০"
        : "Implementation of adolescent nutrition activities, Guideline 2020";
      this.h_body_l_p.l_head_p = this.translate
        ? " কৈশোরকালীন পুষ্টি কার্যক্রম বাস্তবায়নের গাইডলাইনটি মাধ্যমিক বিদ্যালয় পর্যায়ে পুষ্টি কার্যক্রমসমূহ বাস্তবায়নের লক্ষ্যে বিভিন্ন অধিদপ্তর, বিভাগ এবং প্রতিষ্ঠানের মধ্যকার কাজের সমন্বয় কৌশলটি ব্যাখ্যা করেছে। একইসাথে অন্যান্য প্রাসঙ্গিক প্রোগ্রামের কর্মকর্তা ও অংশীদারগণ মাধ্যমিক বিদ্যালয়ভিত্তিক ক্লাব, মাদ্রাসা, কিশোর-কিশোরীদের কমিউনিটি ক্লাব এবং কিশোর-কিশোরীদের স্বাস্থ্যসেবা প্রদানকারী দপ্তরগুলোর সংশ্লিষ্ট কার্যক্রম পরিকল্পনা, বাস্তবায়ন, পর্যবেক্ষণের জন্য এই নীতিমালা রেফারেন্স টুল হিসেবে ব্যবহার করবেন।"
        : "The guideline for the implementation of adolescent nutrition activities explains the coordination strategy of work between different departments, divisions and institutions for the implementation of nutrition activities at the secondary school level.At the same time, officials and partners of other relevant programs will use this policy as a reference tool for planning, implementing and monitoring the activities of secondary school-based clubs, madrasas, adolescent community clubs and adolescent healthcare departments.";
      this.h_body_b2.l_head_b = this.translate ? "গাইড লাইন" : "Guideline";

      this.h_body_right2.right_head2 = this.translate
        ? "মোবাইল প্লাটফর্ম"
        : "Mobile Application";
      this.h_body_right2_p.right_head2_p = this.translate
        ? " মোবাইল প্লাটফর্ম থেকেও যে কোনো সময় যে কোনো স্থান থেকে অফলাইনে পুষ্টি বিষয়ক অনলাইন কোর্সে অংশগ্রহণের মাধ্যমে ব্যাবহারকারীরা বিভিন্ন বিষয়ে জ্ঞান ও দক্ষতা অর্জন করতে পারবেন।"
        : "Users will also be able to acquire knowledge and skills in various subjects by participating in courses on nutrition from anytime, anywhere from the mobile platform.";
      //Edit_profile
      this.edit_pass.edit_text = this.translate
        ? "পুরানো পাসওয়ার্ড"
        : "Old Password";
      this.edit_pass_n.edit_text_n = this.translate
        ? "নতুন পাসওয়ার্ড"
        : "New Password";
      this.edit_pass_r.edit_text_r = this.translate
        ? "নতুন পাসওয়ার্ড নিশ্চিত করুন"
        : "Re-Type New Password";
      this.edit_pro_b.edit_pro_b_text = this.translate ? "আপডেট পাসওয়ার্ড" : "Update";
      //profile
      this.Mycourse_pro.text_pro = this.translate ? "প্রোফাইল" : "Profile";
      this.model.text_model = this.translate ? "চলমান মডিউল" : "Ongoing Course";
      this.model_course.text_model_c = this.translate ? "কোর্স" : "Course";
      this.model_date.text_model_d = this.translate ? "তারিখ" : "Date";
      this.new_course.text_new = this.translate ? "নতুন কোর্স" : "New Course";
      //course description
      this.course_des_p.text_des_p = this.translate
        ? "কোর্সের উদ্দেশ্য"
        : "Course Porpuse";
      this.course_des_m.text_des_m = this.translate
        ? "কোর্সের উদ্দেশ্য"
        : "Course method";
      this.course_des_c.text_des_c = this.translate ? "পাঠতালিকা" : "Contents";
      this.course_des_m_t.text_des_m_t = this.translate
        ? "মোট মডিউল :"
        : "Total Module :";
      this.course_des_m_tt.text_des_m_tt = this.translate ? "টি" : "";
      this.course_des_t_t.text_des_t_t = this.translate
        ? "মোট সময় :"
        : "Total Time:";
      this.course_des_t_tt.text_des_t_tt = this.translate ? "ঘণ্টা" : "Hrs.";
      this.course_des_t_m.text_des_t_m = this.translate ? "মিনিট" : "min.";
      this.h_body_buton_q.q_button = this.translate ? "অনলাইনে শুরু করুন" : "Get started online";
      //review
      this.review.text_review = this.translate ? "মূল্যায়ন" : "Review";
      this.review_q.text_review_q = this.translate
        ? "এই কোর্সের সাথে আপনার অভিজ্ঞতা কেমন ছিল?"
        : "How was your experience with this course?";
      this.review_q1.text_review_q1 = this.translate
        ? "এই কোর্সটির উদ্দেশ্যগুলি পরিষ্কার ছিল :"
        : "The objectives of this course were clear :";
      this.review_q2.text_review_q2 = this.translate
        ? "কোর্সটি থেকে শিক্ষণীয় বিষয়গুলি জানতে পেরেছি"
        : "I have learned the instructive subjects from the course";
      this.review_q3.text_review_q3 = this.translate
        ? "কোর্সটি আমার কাজের ক্ষেত্রে প্রাসঙ্গিক/প্রযোজ্য"
        : "The course is relevant to my work";
      this.review_q4.text_review_q4 = this.translate
        ? "আপনি কি আপনার সহকর্মীদের বা বন্ধুদের এই কোর্সটি সম্পর্কে জানাবেন ?"
        : "Would you tell your co-workers or friends about this course??";
      this.review_ans.text_review_ans = this.translate
        ? "অসন্তোষজনক"
        : "Unsatisfactory";
      this.review_ans1.text_review_ans1 = this.translate
        ? "সন্তোষজনক"
        : "Satisfactory";
      this.review_ans2.text_review_ans2 = this.translate ? "ভাল" : "Good";
      this.review_ans3.text_review_ans3 = this.translate ? "খুব ভাল" : "Very Good";
      this.review_ans4.text_review_ans4 = this.translate ? "চমৎকার" : "Excellent";
      this.review_ans5.text_review_ans5 = this.translate ? "অসম্মতি" : "Disagree";
      this.review_ans6.text_review_ans6 = this.translate ? "একমত" : "Agree";
      this.review_ans7.text_review_ans7 = this.translate ? "কোন মন্তব্য নেই" : "No comments";
      this.review_ans8.text_review_ans8 = this.translate ? "হ্যাঁ" : "Yes";
      this.review_ans9.text_review_ans9 = this.translate ? "না" : "No";
      this.review_submit.text_review_submit = this.translate ? "জমা দিন" : "Submit";
      //certificate
      this.certificate.text_cer = this.translate ? "সনদপত্র" : "Certificate";
      this.certificate_h.text_cer_h = this.translate
        ? "সনদপত্রটি ডাউনলোড করুন"
        : "Download the Certificate";
      this.certificate_b.text_cer_b = this.translate ? "ডাউনলোড" : "Download";

      // Call Registration API reload if needed
      if (this.registration_hook != null) {
        this.registration_hook.reloadAPI();
      }

      // Call Reload API on Pages
      if (this.page_hook != null) {
        console.log("Page Hook: API Called");
        this.page_hook.reloadAPI();
      }
    },
  },
  render: (h) => h(App),
}).$mount("#app");
